import { render } from "./DockingModal.vue?vue&type=template&id=1b77a188&scoped=true"
import script from "./DockingModal.vue?vue&type=script&lang=js"
export * from "./DockingModal.vue?vue&type=script&lang=js"

import "./DockingModal.vue?vue&type=style&index=0&id=1b77a188&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b77a188"]])

export default __exports__